module.exports = __webpack_public_path__ + "static/media/proclear.9b896354.jpg";